import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Stamp, {MARIGOLD} from 'src/components/Stamp/Stamp';
import Icon from 'shared/components/icon';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const BoostTestScoresText = ({showTooltipFlag = false}) => {
  const infoText = 'Add or boost test scores to earn';
  if (!showTooltipFlag) {
    return (
      <Stamp color={MARIGOLD}>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={MARIGOLD} className="flag">
            <Icon iconType="flag" color="orange" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};
BoostTestScoresText.propTypes = propTypes;
export default BoostTestScoresText;
